import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "synch"
const SynchIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 6.818V9.41l3.5-3.454L12 2.5v2.59c-3.866 0-7 3.094-7 6.91 0 1.356.403 2.617 1.085 3.68l1.278-1.262A5.043 5.043 0 0 1 6.75 12c0-2.862 2.35-5.182 5.25-5.182Zm5.915 1.503-1.278 1.26A5.17 5.17 0 0 1 17.25 12c0 2.862-2.35 5.182-5.25 5.182V14.59l-3.5 3.454L12 21.5v-2.59c3.866 0 7-3.094 7-6.91a6.785 6.785 0 0 0-1.085-3.68v.001Z" />
    </svg>
  )
}
export default SynchIcon
